export default __webpack_public_path__ + "static/Pala_23-67ce839d674616356bde113a8020d67f.png";